module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-mailGreenL-fd3cd55b0c8be9502c3db57658c6b9fd.png";